import { FakeAthleteList } from "../heat/HeatCardSkeleton";

export const LeaderboardSkeleton = () => (
    <div className="skeleton">
        <FakeAthleteList names={[44, 57, 33, 48]} />
    </div>
);
